import { membersBaseURL } from "@/functions/helpers";

const baseURL = membersBaseURL();

const _post = (url, params, config = {}) =>
  window.axios.post(url, params, { baseURL, ...config });
const _put = (url, params) => window.axios.put(url, params, { baseURL });
const _delete = url => window.axios.delete(url, { baseURL });
const _get = url => window.axios.get(url, { baseURL });

export default {
  getAll(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return _get(`/courses/${params.product_id}?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setLessons", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  get(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return _get(`/courses/lessons/list/${params.module_id}?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setLessons", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  getDetails(context, id) {
    return new Promise((resolve, reject) => {
      _get(`/courses/lessons/${id}`)
        .then(({ data }) => {
          context.commit("setLesson", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      _post("/courses/lessons", params)
        .then(resolve)
        .catch(reject);
    });
  },
  duplicate(context, id) {
    return new Promise((resolve, reject) => {
      _post(`/courses/duplicate/lesson/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  clone(context, params) {
    return new Promise((resolve, reject) => {
      _post(`/courses/duplicate/lesson-to`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/courses/lessons/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  reorder(context, lessons) {
    return new Promise((resolve, reject) => {
      _put(`/courses/lessons/reorder`, { lessons })
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      _delete(`/courses/lessons/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  uploadFile(context, { files, id }) {
    var formData = new FormData();
    for (let i in files) {
      formData.append("file", files[i]);
    }

    return new Promise((resolve, reject) => {
      _post(`/courses/lessons/extra-files/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
        .then(resolve)
        .catch(reject);
    });
  },
  getFiles(context, id) {
    return new Promise((resolve, reject) => {
      _get(`/courses/lessons/extra-files/${id}`)
        .then(({ data }) => {
          context.commit("setFiles", data.results);
          resolve(data);
        })
        .catch(reject);
    });
  },
  deleteFile(context, id) {
    return new Promise((resolve, reject) => {
      _delete(`/courses/lessons/extra-files/delete/${id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
